export default __webpack_public_path__ + "static/media/pdf.525d89a3.svg";